import { render, staticRenderFns } from "./tab13.vue?vue&type=template&id=71703c52&scoped=true&"
import script from "./tab13.vue?vue&type=script&lang=js&"
export * from "./tab13.vue?vue&type=script&lang=js&"
import style0 from "./tab13.vue?vue&type=style&index=0&id=71703c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71703c52",
  null
  
)

export default component.exports